import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class RolesApi extends BaseApi {
  async addRole(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
      {
        url: "/roles/addrole",
        data: data,
        method: "post"
      }
    )
  }
  async getAllRoleList(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
      {
        url: "/roles/getallrolelist",
        method: "get"
      }
    )
  }

  async getAllRoleSearch(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
      {
        url: "/roles/getAllRoleSearch",
        method: "get"
      }
    )
  }

  async getRole(data: Record<string, unknown> | object, role_id: IdLike): Promise<any> {
    return await this.API(
      {
        url: `/roles/getrole/${role_id}`,
        method: "get"
      }
    )
  }
  async deleteRole(data: Record<string, unknown> | object, role_id: IdLike): Promise<any> {
    return await this.API({
      url: `/roles/deleterole/${role_id}`,
      data: data,
      method: 'delete'
    })
  }
  async searchRole(data: Record<string, unknown> | object, key: string): Promise<any> {
    return await this.API(
      {
        url: `/roles/searchrole/${key}`,
        method: "get"
      }
    )
  }
  async updateRole(data: Record<string, unknown> | object, role_id: IdLike): Promise<any> {
    return await this.API({
      url: `/roles/updaterole/${role_id}`,
      data: data,
      method: 'put'
    })
  }

}

export default RolesApi;
